import { ActivityKind } from "@visioni/a3s-activity-recorder/types";
import { match } from "ts-pattern";

export function activityKindToShortLabel(kind: ActivityKind): string {
  return match(kind)
    .with("alarm_activated", () => "Alarm activated")
    .with("alarm_routine_configured", () => "Alarm routine")
    .with("alarm_response_configured", () => "Alarm response")
    .with("alarm_exception_configured", () => "Alarm exception")
    .with("alarm_timezone_configured", () => "Alarm timezone")
    .with("alarm_override_configured", () => "Alarm override")
    .with("alarm_silence_configured", () => "Alarm silence")
    .with("alarm_contacts_configured", () => "Alarm contacts")
    .with("site_alarm_override_configured", () => "Site override")
    .with("user_permission_granted", () => "User access granted")
    .with("user_permission_revoked", () => "User access revoked")
    .with("livestream_viewed", () => "Livestream viewed")
    .with("clip_viewed", () => "Clip viewed")
    .with("clip_compilation_requested", () => "Compilation requested")
    .with("clip_compilation_viewed", () => "Compilation viewed")
    .with("test_signal_triggered", () => "Test signal")
    .with("deterrence_triggered", () => "Deterrence trigger sent")
    .with("deterrence_stopped", () => "Deterrence stop sent")
    .exhaustive();
}

export function activityKindToLabel(kind: ActivityKind): string {
  return match(kind)
    .with("alarm_activated", () => "Alarm activated")
    .with("alarm_routine_configured", () => "Alarm routine change")
    .with("alarm_response_configured", () => "Alarm response change")
    .with("alarm_exception_configured", () => "Alarm exception change")
    .with("alarm_timezone_configured", () => "Alarm timezone change")
    .with("alarm_override_configured", () => "Alarm override change")
    .with("alarm_silence_configured", () => "Alarm silence change")
    .with("alarm_contacts_configured", () => "Alarm contacts change")
    .with("site_alarm_override_configured", () => "Site alarm override change")
    .with("user_permission_granted", () => "User permission granted")
    .with("user_permission_revoked", () => "User permission revoked")
    .with("livestream_viewed", () => "Livestream viewed")
    .with("clip_viewed", () => "Clip viewed")
    .with("clip_compilation_requested", () => "Clip compilation requested")
    .with("clip_compilation_viewed", () => "Clip compilation viewed")
    .with("test_signal_triggered", () => "Test signal triggered")
    .with("deterrence_triggered", () => "Deterrence trigger command sent")
    .with("deterrence_stopped", () => "Deterrence stop command sent")
    .exhaustive();
}
